import React from 'react';
import { useTranslation } from 'react-i18next';

import { DialogMessageContents, ModalDialog } from '@/components/Elements';

/**
 * プロパティ
 */
type Props = {
  // ダイアログ表示/非表示(true=表示)
  isOpen: boolean;
  // OKボタンクリック時の処理
  onClickOKButton: () => void;
};

/**
 * 共有停止お知らせダイアログ コンポーネント
 */
export const ShareInactiveDialog = React.memo(
  ({ isOpen, onClickOKButton }: Props) => {
    const { t } = useTranslation();

    return (
      <ModalDialog
        isOpen={isOpen}
        isHiddenCloseButton
        title={t('shareInactiveDialog.共有が停止されました').toString()}
        buttons={[
          { label: 'OK', onClick: onClickOKButton, gtmClassTag: 'dialog-19' },
        ]}
      >
        <DialogMessageContents>
          {t('shareInactiveDialog.主催者により共有が停止されました。')}
        </DialogMessageContents>
      </ModalDialog>
    );
  },
);
